export enum PaginatorEventType {
  NextPage = 'nextPage',
  PrevPage = 'prevPage',
  FirstPage = 'firstPage',
  LastPage = 'lastPage',
  UpdatePgDropdown = 'updatePgDropdown',
  UpdatePgSize = 'updatePgSize'
}
